import styled from 'styled-components';
export var Inner = styled.div.withConfig({
  displayName: "partials__Inner",
  componentId: "sc-138q6ot-0"
})(["margin:30px auto;svg{margin-left:4px;vertical-align:middle;}"]);
export var LoadButton = styled.button.withConfig({
  displayName: "partials__LoadButton",
  componentId: "sc-138q6ot-1"
})(["display:inline-block;width:100%;border:0 solid ", ";border-radius:4px;cursor:pointer;font-family:", ";font-size:15px;font-weight:700;color:", ";text-align:center;transition:all 0.15s ease;&:hover{border-color:", ";color:", ";}&[disabled]{border:none;border-color:", ";color:", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.ui;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.bodyFontFamily;
}, function (_ref3) {
  var theme = _ref3.theme,
    light = _ref3.light;
  return light ? theme.fontLightColor : theme.colors.primary;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.primary;
}, function (_ref5) {
  var theme = _ref5.theme,
    disabled = _ref5.disabled;
  return disabled ? theme.fontLightColor : theme.colors.primary;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.uiD;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.uiD;
});